<template>
  <div>
    <nav-bar ref="form"/>
    <div class="sec-wight-bg py-16 ">
      <div class="container sec-garay-bg border-radius ">
        <div class="row ">
          <h5 class="text-blue col py-0">
            <page-title :titles="'محصولات'"/>
          </h5>
        </div>
      </div>
      <div v-if="Products.length >0" class="container p-md-0" dir="ltr">
        <div class="row">
          <div class="col-12 col-md-3 " v-for="item in Products" :key="item.id">
            <router-link :to="{path:'productDetails',query:{productId:item.id}}">
              <div class="bg-Products white--text text-center border-radius-productName py-4">{{
                  item.productName
                }}
              </div>
              <div class="sec-garay-bg  p-4">
                <div class="">
                  <v-img :src="$replaceHttps(item.imageUrl)" class="mx-auto" width="150" height="150"></v-img>
                </div>
              </div>
            </router-link>
            <div class="bg-product-btn white--text text-center border-radius-product-btn py-4 "><a>مشاهده بیشتر</a>
              <div class="col-auto">
                <v-btn
                    v-if="!$productExistsInCompare(item.id)"
                    @click="addToCompareProducts(item.id)"
                    class="py-4"
                    color="primary"
                    small>
                  مقایسه
                </v-btn>
                <v-btn
                    v-else
                    @click="removeFromCompareProducts(item.id)"
                    class="py-4"
                    color="primary"
                    small>
                  حذف از مقایسه
                </v-btn>
                <!--      <v-btn
                              v-else

                              class="py-4"
                              color="primary"
                              small>
                           حذف
                      </v-btn>-->
              </div>
            </div>
          </div>
        </div>
        <!--        <v-alert
                    v-else
                    dense
                    outlined
                    type="error">محصولی یافت نشد
                </v-alert>-->
      </div>
      <v-alert
          v-else
          dense
          outlined
          type="error">محصولی یافت نشد
      </v-alert>
      <v-dialog
          v-model="showResultDialog"
          hide-overlay
          persistent
          width="500">
        <v-card class="text-center">
          <v-card-title class="justify-space-between bg-Products">
            <v-btn
                class="mr-2"
                icon
                @click="showResultDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pt-6">
            <div class="mb-0 black--text py-5">{{ dialogResult }}</div>
          </v-card-text>
          <router-link to="compare">
            <v-btn
                color="primary"
                class="m-3"
            >
              مشاهده
            </v-btn>
          </router-link>
        </v-card>
      </v-dialog>
    </div>
    <footer-menu></footer-menu>
    <v-overlay
        id="searchOverLay"
        :absolute="false"
        :color="'#f7f1fc'"
        :opacity="0.7"
        :value="showLoaderDialog"
        :z-index="6">
      <div class="row h-100 align-items-center justify-content-center">
        <div class="loading-spinner">
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import FooterMenu from "@/components/footer";
import PageTitle from "@/components/titles";

export default {
  name: "allProducts",
  components: {PageTitle, FooterMenu, NavBar},
  metaInfo: {
    title: 'ماشین سازان اصلانیان-محصولات'
  },
  data: () => ({
    showLoaderDialog: false,
    isPageLoaded: false,
    Products: [],
    showResultDialog: false,
    dialogResult: null,
  }),
  mounted() {
    this.$refs.form.checkCompareNumber()
    this.getData()
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
    removeFromCompareProducts(id) {
      this.showResultDialog = true
      this.dialogResult = 'محصول مورد نظر از لیست مقایسه حذف شد'
      this.$removeFromCompare(id);
      this.$refs.form.checkCompareNumber()
      // this.getData();

    },
    addToCompareProducts(id) {
      this.showResultDialog = true
      this.dialogResult = 'محصول مورد نظر به لیست مقایسه اضافه شد'
      this.$addToCompare(id);
      this.$refs.form.checkCompareNumber()
      // this.getData();
    },

    getData() {
      this.showLoaderDialog = true;
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/Products", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.isPageLoaded = true
            let json = JSON.parse(result);
            this.Products = json.filter(x => x.isActive === true)
            this.showLoaderDialog = false;
            console.log("this.Products")
            console.log(this.Products)
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>